import React, { useState, useEffect } from "react";
import "./HeroSlider.css";

import LandingPage from "./LandingPage";
import ServicesPage from "./ServicesPage";
import ContactSection from "./ContactSection";

import {
  FaTruck,
  FaTruckMoving,
  FaPhoneAlt,
  FaArrowLeft,
} from "react-icons/fa";

import { GiCrane } from "react-icons/gi";

export default function HeroSlider() {
  const images = [
    "/img1.jpeg",
    "/img2.jpeg",
    "/img3.jpeg",
  ];

  const services = [
    {
      icon: <GiCrane />,
      title: "מנופים",
      text: "הרמה ושינוע מקצועי",
    },
    {
      icon: <FaTruck />,
      title: "הובלות",
      text: "הובלות לכל הארץ",
    },
    {
      icon: <FaTruckMoving />,
      title: "הובלות מורכבות",
      text: "פתרונות לפרויקטים מיוחדים",
    },
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <>
      <section className="hero-section">

        {/* תמונת רקע */}
        <img
          src={images[index]}
          alt="ש.מ הובלות ומנופים"
          className="hero-background"
        />

        {/* שכבות כהות */}
        <div className="hero-overlay"></div>
        <div className="hero-glow"></div>

        {/* =====================================================
            תוכן מרכזי
        ====================================================== */}

        <div className="hero-content">

 

          <h1>
            ש.מ הובלות
            <br />
            <span>ומנופים</span>
          </h1>

          <div className="hero-line"></div>

          <h2>
            פתרונות מקצועיים להובלה,
            <br />
            הרמה ושינוע בכל הארץ
          </h2>

          <p>
            ציוד מתקדם, צוות מקצועי וביצוע מדויק
            <br />
            לכל סוגי הפרויקטים
          </p>

          {/* כפתורים */}

          <div className="hero-buttons">

     

            <a href="#services" className="secondary-button">
              לשירותים שלנו
              <FaArrowLeft />
            </a>

          </div>

        </div>

        {/* =====================================================
            כרטיסי שירותים
        ====================================================== */}

        <div className="hero-services">

          {services.map((service, i) => (
            <div className="hero-service-card" key={i}>

              <div className="hero-service-icon">
                {service.icon}
              </div>

              <div className="hero-service-text">

                <strong>
                  {service.title}
                </strong>

                <span>
                  {service.text}
                </span>

              </div>

            </div>
          ))}

        </div>

        {/* =====================================================
            נקודות סליידר
        ====================================================== */}

        <div className="slider-dots">

          {images.map((_, i) => (
            <button
              key={i}
              className={index === i ? "active" : ""}
              onClick={() => setIndex(i)}
              aria-label={`תמונה ${i + 1}`}
            />
          ))}

        </div>

      </section>

      {/* שאר הדפים */}

      <div id="services">
        <ServicesPage />
      </div>

      <LandingPage />


      <ContactSection />
    </>
  );
}
